export default "__VITE_ASSET__BK6q0N1Q__"